<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <!-- <img src="~@/assets/brand_img/stockvault.jpg"> -->
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title" />
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png" />
        <span class="place">您的位置：<span @click="goHome">主页</span>＞<span class="brandshow" @click="goBrandshow">品牌与产品</span>＞{{this.productName}}</span>
      </div>
    </div>
    <div class="showproduct">
      <div class="introduce">
        <div class="left">
          <div class="slideshow">
            <ul>
              <!-- <li
                v-for="(img, index) in imgArray"
                :key="index"
                v-show="index === mark"
              >
                <img :src="img">
              </li> -->
              <li>
                <img :src="this.lunboImg">
              </li>
            </ul>
          </div>
          <!-- <div class="bar">
            <span
              v-for="(item, index) in imgArray"
              :key="index"
              :class="{ active: index === mark }"
            @click="change(index)"></span>
          </div> -->
        </div>
        <div class="right">
          <p>{{this.productName}}</p>
          <p>品牌：HUZER</p>
          <p>分类：{{this.categoryName}}</p>
          <p>型号：{{this.productModel}}</p>
          <p>产品优势：{{this.productAdvantage}}</p>
          <p>
            淘宝购买链接：<span @click="taobao" class="taobao">{{this.buyLink}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="showMore">
      <div class="product">
          <div class="hotProduct">
            <ul>
              <li>
                <div class="hotTitle">热销产品</div>
                <div>
                  <img src="~@/assets/brand_img/wuxian_v1.0.png" @click="product(3)">
                  <div class="line"></div>
                  <div class="simpleIntroduce">
                    <p @click="product(3)">无线手持终端系统 V1.0</p>
                    <span>品牌：HUZER</span><span @click="product(3)">了解更多</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="hotTitle">热销产品</div>
                <div>
                  <img src="~@/assets/brand_img/railwayBroadcast1.0.png" @click="product(8)">
                  <div class="line"></div>
                  <div class="simpleIntroduce">
                    <p @click="product(8)">火车站客运广播平台 V1.0</p>
                    <span>品牌：HUZER</span><span @click="product(8)">了解更多</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="moreIntroduce">
            <div class="productChoose"><span @click="overview" id="overview">产品概述</span><span @click="parameter" id="parameter">产品参数</span><span @click="gallery" id="gallery">产品图库</span></div>
            <div class="line"></div>
            <div id="productOverview">
              <img :src="this.overviewImg">
            </div>
            <div id="productParameters">
              <img :src="this.parameterImg">
            </div>
            <div id="productGallery">
              <!-- <img v-for="(item,index) in galleryList" :key="index" src='require("../../assets/brand_img/lunbo61.png")'> -->
              <img :src="this.lunboImg">
              <img :src="this.lunboImg_2">
              <img :src="this.lunboImg_3">
              <img :src="this.lunboImg_4">
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      productId: '',
      mark: 0,
      imgArray: [
        // require('' + this.lunboImg),
        // require('' + this.lunboImg_2),
        // require('' + this.lunboImg_3),
        // require('' + this.lunboImg_4)
        // { url: require('@/assets/brand_img/' + this.lunboImg_1) },
        // { url: require('@/assets/brand_img/' + this.lunboImg_2) }
        // { url: require('@/assets/brand_img/HZGB03-01-02_2.png') },
        // { url: require('@/assets/brand_img/HZGB03-01-02_3.png') }
      ],
      // galleryList: [
      //   // {src: this.lunboImg_1, src: this.lunboImg_2, src: this.lunboImg_3, src: this.lunboImg_4}
      // ],
      productsrc: '',
      productName: '',
      productModel: '',
      productAdvantage: '',
      buyLink: '',
      overviewImg: '',
      parameterImg: '',
      lunboImg: '',
      lunboImg_2: '',
      lunboImg_3: '',
      lunboImg_4: '',
      categoryName: ''
    }
  },
  methods: {
    // lunbo (id) {
    //   // var that = this
    //   this.$axios.post('http://localhost:8081/api/user/selectLunbo', this.$qs.stringify({
    //     productId: id
    //   }))
    //     .then(function (res) {
    //       // console.log(this.productId + '-----------')
    //       console.log(res.data + '1111111111')
    //       // that.galleryList = res.data
    //       // that.imgArray = res.data
    //       // console.log(that.galleryList)
    //     })
    //     .catch(function (res) {
    //       console.log(res.data)
    //     })
    // },
    goBrandshow () {
      this.$router.push(
        {
          path: '/brand'
        }
      )
      location.reload()
    },
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    },
    autoPlay () {
      this.mark++
      if (this.mark === this.imgArray.length) {
        // 当遍历到最后一张图片置零
        this.mark = 0
      }
    },
    play () {
      setInterval(this.autoPlay, 2500)
    },
    change (i) {
      this.mark = i
    },
    stop () {
      clearInterval(this.timer)
    },
    move () {
      this.timer = setInterval(this.autoPlay, 2500)
    },
    overview () {
      document.getElementById('productOverview').style.display = 'block'
      document.getElementById('productParameters').style.display = 'none'
      document.getElementById('productGallery').style.display = 'none'
      document.getElementById('overview').style.color = '#af0003'
      document.getElementById('parameter').style.color = '#444444'
      document.getElementById('gallery').style.color = '#444444'
    },
    parameter () {
      document.getElementById('productOverview').style.display = 'none'
      document.getElementById('productParameters').style.display = 'block'
      document.getElementById('productGallery').style.display = 'none'
      document.getElementById('overview').style.color = '#444444'
      document.getElementById('parameter').style.color = '#af0003'
      document.getElementById('gallery').style.color = '#444444'
    },
    gallery () {
      document.getElementById('productOverview').style.display = 'none'
      document.getElementById('productParameters').style.display = 'none'
      document.getElementById('productGallery').style.display = 'block'
      document.getElementById('overview').style.color = '#444444'
      document.getElementById('parameter').style.color = '#444444'
      document.getElementById('gallery').style.color = '#af0003'
    },
    getProductMessage () {
      var that = this
      this.$axios.post('http://' + this.global.url + ':8081/api/user/selectProductMessage', this.$qs.stringify({
        productId: this.productId
      }))
        .then(function (res) {
          console.log(res.data)
          // that.productMessage = res.data
          // 产品名称
          that.productName = res.data[0].productName
          that.productsrc = res.data[0].productsrc
          // 产品型号
          that.productModel = res.data[0].productModel
          // 产品优势
          that.productAdvantage = res.data[0].productAdvantage
          // 淘宝链接
          that.buyLink = res.data[0].buyLink
          // 产品概述
          that.overviewImg = require('../../assets/brand_img/' + res.data[0].overviewImg)
          // console.log(that.overviewImg + '+++++++')
          // console.log(this.overviewImg + '+++++++')
          // 参数
          that.parameterImg = require('../../assets/brand_img/' + res.data[0].parameterImg)
          // 图库
          that.lunboImg = require('../../assets/brand_img/' + res.data[0].lunboImg)
          console.log(that.lunboImg + '-------------')
          that.lunboImg_2 = require('../../assets/brand_img/' + res.data[0].lunboImg_2)
          // console.log(that.lunboImg_2 + '2222222222')
          that.lunboImg_3 = require('../../assets/brand_img/' + res.data[0].lunboImg_3)
          that.lunboImg_4 = require('../../assets/brand_img/' + res.data[0].lunboImg_4)
          // 分类
          that.categoryName = res.data[0].categoryName
        })
        .catch(function (res) {
          console.log(res.data)
        })
    },
    taobao () {
      window.open(this.buyLink, '_blank')
    },
    product (id) {
      console.log(id)
      this.$router.push(
        {
          path: '/showBrand',
          query: {
            productId: id
          }
        }
      )
      location.reload()
    }
  },
  created () {
    this.play()
    this.productId = this.$route.query.productId
    this.getProductMessage()
    // this.lunbo(this.productId)
  }
}
</script>
<style scoped>
.brandshow{
  cursor: pointer;
}
.showproduct{
  width: 70%;
  /* height: auto; */
  /* margin-left: 15%; */
  margin: 0 auto;
  margin-top: 20px;
  background-color: #f5f5f5;
  border: #eaeaea solid 1px;
}
.introduce {
  width: 80%;
  height: auto;
  /* border: red solid 1px; */
  /* background-color: #f5f5f5; */
  padding-top: 50px;
  padding-bottom: 50px;
  margin-left: 10%;
  display: flex;
}
.introduce .left {
  width: 40%;
  /* height: 300px; */
  /* background-color: white; */
  /* display: inline-block; */
  position: relative;
  flex-wrap: wrap;
  /* float: left; */
}
.slideshow {
  width: 100%;
  height: 300px;
  background-color: white;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  /* border:red 1px solid; */
}
.slideshow ul {
  list-style: none;
}
.slideshow img {
  width: 50%;
  height: auto;
  /* margin-left: 25%; */
  /* line-height: 300px; */
}
.bar {
  /* position: absolute; */
  width: 100%;
  /* bottom: 10px; */
  margin: 0 auto;
  z-index: 10;
  text-align: center;
}
.bar span {
  width: 10px;
  height: 10px;
  /* border: 1px solid; */
  background: gray;
  display: inline-block;
  margin-right: 10px;
  border-radius: 50%;
}
.active {
  background: red !important;
}
.introduce .right {
  width: 50%;
  height: auto;
  position: relative;
  left: 5%;
  flex-wrap: wrap;
}
.introduce .right p:first-child {
  font-size: 30px;
  color: #555555;
  margin-top: 0;
}
.introduce .right p:nth-child(2) {
  margin-top: 3%;
}
.introduce .right p {
  color: #666666;
  padding-top: 2%;
}
.taobao{
  width: 100%;
  height: auto;
  word-wrap:break-word;
  word-break:break-all;
  overflow: hidden;
  cursor: pointer;
}
.showMore{
  width: 70%;
  margin: 0 auto;
  margin-top: 20px;
}
.product {
  width: 100%;
  height: auto;
  /* border: red solid 1px; */
  /* background-color: #f5f5f5; */
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
}
.hotProduct{
width: 25%;
height: 300px;
/* border:solid 1px red; */
position: relative;
flex-wrap: wrap;
display: table-cell;
vertical-align: middle;
text-align: center;
}
.hotProduct ul{
  list-style: none;
  padding-bottom: 50px;
}
.hotProduct ul li{
  width: 100%;
  border: #eaeaea solid 1px;
  box-shadow: 3px 3px 2px #eaeaea;
}
.hotProduct ul li:last-child{
  margin-top: 50px;
}
.hotProduct img{
  width: 50%;
  margin-top: 20px;
  cursor: pointer;
}
.hotTitle{
  width: 100%;
  height: 50px;
  background-color: #e4393c;
  text-align: center;
  font-size: 25px;
  color: white;
  line-height: 50px;
}
.line{
  width: 80%;
  border: 1px solid #eaeaea;
  margin-left: 10%;
  margin-top: 20px;
  background-color: #eaeaea;
}
.moreIntroduce{
width: 70%;
height: auto;
border: #eaeaea 1px solid;
position: relative;
flex-wrap: wrap;
left: 3%;
}
.simpleIntroduce{
  padding-bottom: 20px;
  cursor: pointer;
}
.simpleIntroduce p{
  width: 80%;
  margin-left: 10%;
  font-size: 20px;
  color: #666666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  margin-top: 5%;
}
.simpleIntroduce span{
  font-size: 14px;
  margin-left: 5%;
  margin-top: 5%;
}
.simpleIntroduce span:first-child{
  margin-left: 0;
}
.simpleIntroduce span:last-child{
  color: #e4393c;
}
.productChoose{
  text-align: center;
  font-size: 18px;
  color: #444444;
  padding-top: 20px;
}
#overview{
  color: #e4393c;
}
#overview,#parameter,#gallery{
  cursor: pointer;
}
.productChoose span:first-child{
  margin-left: 0;
}
.productChoose span{
  margin-left: 10%;
}
#productOverview,#productParameters,#productGallery{
  width: 100%;
  height: auto;
  text-align: center;
  /* border: solid 1px red; */
}
/* #productOverview,#productParameters,#productGallery img{
  width: 100%;
} */
#productParameters,#productGallery{
  display: none;
}
#productOverview,#productParameters,#productGallery img{
  width: 100%;
  height: 100%;
  /* margin-left: 20%; */
}
#productGallery img{
  margin-left: 0;
}
@media screen and (min-width: 1500px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/brand_img/stockvault.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 900px;
    margin-top: 25px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: 1%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 产品 */
}
@media screen and (min-width: 1200px) and (max-width: 1499px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/brand_img/stockvault.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 750px;
    margin-top: 20px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -3%;
    margin-left: 14.5%;
    font-size: 18px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 产品 */
  .showproduct,.showMore{
    width: 70%;
  }
}
@media screen and (min-width: 960px) and (max-width: 1199px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/brand_img/stockvault.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 600px;
    /* margin-left: 20px; */
    margin-top: 10px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -6%;
    margin-left: 14.5%;
    font-size: 16px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 3%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 产品 */
.showproduct,.showMore{
    width: 70%;
  }
}
@media screen and (min-width: 768px) and (max-width: 959px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/brand_img/stockvault.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 400px;
    /* margin-left: 30px; */
    /* margin-top: 10px; */
  }
  /* 位置 */
  .location {
    width: auto;
    height: 20px;
    /* border: 1px red solid; */
    margin-top: -11%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 3%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 产品 */
  .showproduct,.showMore{
    width: 70%;
  }
}
@media screen and (min-width: 702px) and (max-width: 767px) {
  /* 顶部 */
  .head {
    width: 100%;
    height: 253px;
    background-image: url("~@/assets/brand_img/stockvault.jpg");
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .title {
    width: 500px;
    margin-left: 50px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 27px;
    /* border: 1px red solid; */
    margin-top: -12%;
    margin-left: 14.5%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 3%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 0.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 产品 */
  .showproduct,.showMore{
    width: 70%;
  }
}
@media screen and (max-width: 701px) {
  .main {
    width: 100%;
    height: auto;
  }
  /* 顶部 */
  .head {
    width: 100%;
    height: auto;
    background-image: url("~@/assets/brand_img/stockvault.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .title {
    width: 50%;
    margin-left: 30%;
    margin-top: 10px;
  }
  /* 位置 */
  .location {
    width: auto;
    height: 20px;
    margin-top: 10px;
    margin-left: 10%;
    font-size: 12px;
    font-family: "宋体";
    /* color: black; */
  }
  .location img {
    width: 6%;
    display: inline-block;
  }
  .place {
    position: relative;
    left: 1.2%;
    top: -5px;
    cursor: pointer;
  }
  /* 产品 */
  .showproduct,.showMore{
    width: 100%;
  }
  .introduce {
  width: 80%;
  height: auto;
  padding-top: 50px;
  padding-bottom: 50px;
  margin-left: 10%;
}
  .introduce .left {
  width: 100%;
}
.slideshow {
  width: 100%;
  height: 200px;
  background-color: white;
  /* display: table-cell;
  vertical-align: middle;
  text-align: center; */
}
.introduce .right {
  width: 100%;
  height: auto;
}
.introduce .right p:first-child {
  font-size: 16px;
  color: #555555;
  margin-top: 0;
}
.introduce .right p:nth-child(2) {
  margin-top: 3%;
}
.introduce .right p {
  font-size: 12px;
  color: #666666;
  padding-top: 2%;
}
.hotTitle{
  width: 100%;
  height: 40px;
  background-color: #e4393c;
  text-align: center;
  font-size: 16px;
  color: white;
  line-height: 40px;
}
.simpleIntroduce p{
  width: 80%;
  margin-left: 10%;
  font-size: 12px;
  color: #666666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  margin-top: 5%;
}
.simpleIntroduce span{
  font-size: 10px;
  margin-left: 5%;
  margin-top: 5%;
}
.productChoose{
  text-align: center;
  font-size: 12px;
  color: #444444;
  padding-top: 20px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/brand/showBrand.vue